module.exports = __webpack_public_path__ + "img/hacksaw.82080893.png";